/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Loading from './components/common/loading/Loading';
import { useTypedSelector } from './hooks/useTypedSelector';
import { useAuth } from './hooks/useAuth';
import { getCurrentUser } from './store/authSlice';
import { useAccess } from './hooks/useAccess';
import { siteMap } from './routing/siteMap';

function App() {
  const { setMyself } = useAuth();
  const user = useTypedSelector(getCurrentUser());
  const { getPageAccess } = useAccess();

  // --
  // -- Remove legacy tokens from localStorage (migrated to httpOnly cookies) and get myself
  // --
  useEffect(() => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    setMyself();
  }, []);

  return user === undefined
    ? <Loading isfullScreen />
    : <RouterProvider
        router={createBrowserRouter(siteMap(window.location.href.replace(window.location.origin, ''), getPageAccess, user))}
        fallbackElement={<> </>}
    />
}

export default App;
